<template>
  <b-card
    v-if="data"
    no-body
    class="card-developer-meetup"
  >
    <div class="bg-light-primary rounded-top text-center">
      <b-img
        :src="data.avatar"
        :alt="data.name"
        height="170"
        class="rounded-circle"
      />
    </div>
    <b-card-body>
      <!-- speaker header -->
      <div class="meetup-header d-flex align-items-center">
        <div class="my-auto">
          <b-card-title class="mb-25">
            {{ data.fullName }}
          </b-card-title>
          <b-card-text class="mb-0">
            {{ data.description }}
          </b-card-text>
        </div>
      </div>
      <!--/ speaker header -->

    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BImg, BCardBody, BCardText, BCardTitle, BMedia, BMediaAside, BAvatar, BAvatarGroup, VBTooltip, BMediaBody, BButton
} from 'bootstrap-vue'

export default {
  name: "SpeakerCard",
  components: {
    BCard,
    BImg,
    BCardBody,
    BCardText,
    BCardTitle,
    BMedia,
    BMediaAside,
    BAvatar,
    BAvatarGroup,
    BMediaBody,
    BButton,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
}
</script>
